import { apiClient } from '@app/api';
import { DownloadUrlButton } from '@app/core/media-player/DownloadUrlButton';

interface Props {
  readonly stationId: string;
  readonly audioId: string;
  /** Time in milliseconds before re-enabling the button after a download click. */
  readonly timeout?: number;
  readonly size?: 'small' | 'medium' | 'large';
  readonly disabled?: boolean;
}

/**
 * Audit-audio download control: builds the forced-download URL and delegates to DownloadUrlButton.
 */
export function DownloadAudioBtn({ stationId, audioId, timeout, size, disabled }: Props) {
  const url = apiClient.audit.getDownloadAudioUrl({
    stationId,
    customId: audioId,
    download: true,
  });

  return (
    <DownloadUrlButton
      url={url}
      timeout={timeout}
      size={size}
      disabled={disabled}
      color="primary"
      iconOnly
    />
  );
}
